import { By } from 'selenium-webdriver';
import { DriverLike, register } from '@oracle/oraclejet-webdriver';
import { ProgressBarWebElement } from './ProgressBarWebElement';
export { ProgressBarWebElement };

/**
 * Retrieve an instance of [ProgressBarWebElement](../classes/ProgressBarWebElement.html).
 * @example
 * ```javascript
 * import { findProgressBar } from '@oracle/oraclejet-core-pack/webdriver';
 * const el = await findProgressBar(driver, By.id('my-oj-c-progress-bar'));
 * ```
 * @param driver A WebDriver/WebElement instance from where the element will be
 * searched. If WebDriver is passed, the element will be searched globally in the
 * document. If WebElement is passed, the search will be relative to this element.
 * @param by The locator with which to find the element
 */
export async function findProgressBar(driver: DriverLike, by: By): Promise<ProgressBarWebElement> {
  const webEl = await driver.findElement(by);
  // Check that the element is of type ProgressBarWebElement
  if (!(webEl instanceof ProgressBarWebElement)) {
    const tagName = await webEl.getTagName();
    let supplemental = '';
    if (webEl.constructor.name === 'ProgressBarWebElement') {
      supplemental = 'You likely have multiple installations of this package.';
    }
    throw Error(
      `findProgressBar(${by}) created ${webEl.constructor.name} for <${tagName}>, but expected ${ProgressBarWebElement.name}. ${supplemental}`
    );
  }
  return webEl;
}

register('oj-c-progress-bar', ProgressBarWebElement);
